<template>
  <div class="CompanyCard">
    <a :href="`/facade/${source}/${real_name}/${nick_name}`" target="_blank">
      <img
        :src="getImagePath(nick_name)"
        :alt="nick_name"
        class="CompanyCard-image"
        @error="handleImageError"
      />
    </a>
    <br />
    <b>{{ real_name }}</b>
  </div>
</template>

<style>
.CompanyCard {
  text-align: center;
  border: solid 1px rgb(221, 246, 233);
  margin: 2px;
  padding: 3px;
  border-radius: 10px;

}
.CompanyCard:hover {
  border: solid 1px rgb(193, 131, 23);
  background-color: pink;
}

.CompanyCard-image {
  max-width: 120px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>

<script>
export default {
  props: ["real_name", "nick_name", "source"],
  data: function () {
    return {
      defaultImage: require("@/assets/img/Default.png"), // Change this to your default image path
    };
  },
  methods: {
    getImagePath(nick_name) {
      try {
        return require(`@/assets/img/${nick_name}.png`);
      } catch (e) {
        return this.defaultImage;
      }
    },
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
  },
  computed: {},
  mounted: function () {},
};
</script>
